<template>
  <b-container v-if="$root.token">
    <br>
    <b-row>
      <b-col cols=2>&nbsp;</b-col>
      <b-col cols=8>
        <h3>Compare/Report Multiple Scoring Events</h3>
      </b-col>
      <b-col cols=2>
        Download full spreadsheet 
        <font-awesome-icon icon="spinner" size="lg" spin v-if="downloading"/>
        <font-awesome-icon icon="file-download" size="lg" v-if="!downloading" @click="multiDownload();"/>
      </b-col>
    </b-row>
    <br>
    <b-container v-if="!loading">
      <b-row>
        <b-col class="font-weight-bold">
          Programme
        </b-col>
        <b-col class="font-weight-bold">
          Customer
        </b-col>
        <b-col class="font-weight-bold">
          Period and Year
        </b-col>
      </b-row>
      <b-row v-for="scoringEvent of scoringEvents" :key="scoringEvent.id">
        <b-col>
          {{ scoringEvent.programmeName }}
        </b-col>
        <b-col>
          {{ scoringEvent.customerName }}
        </b-col>
        <b-col>
          {{ scoringEvent.period }} {{ scoringEvent.year }}
        </b-col>
      </b-row>
    </b-container>
    <font-awesome-icon icon="spinner" size="lg" spin v-if="loading"/>
    <survey-analysis :survey-runs="scoringEvents" v-if="!loading"/>
  </b-container>
</template>
<script>

import * as API from "@/services/API";
import SurveyAnalysis from "@/components/SurveyAnalysis.vue";


export default {
  name: "MultiAnalyse",
  components: { SurveyAnalysis },
  data: function() {
    return {
      scoringEvents: [],
      loading: true,
      downloading: false
    }
  },
  mounted: async function() {
    //return Promise.all(this.$route.query.scoringEventIds.map(scoringEventId => API.getSurveyRunSummary(scoringEventId, this.$root.token))).then(results => {
    //  this.scoringEvents = results;
    //});
    this.loading = true;
    this.scoringEvents = await Promise.all(this.$route.query.scoringEventIds.map(scoringEventId => API.getSurveyRunSummary(scoringEventId, this.$root.token)));
    this.loading = false;
    console.log(this.scoringEvents);
  },
  methods: {
    multiDownload: async function() {
      this.downloading = true;
      const file = await API.getMultiReport(this.scoringEvents.map(scoringEvent => scoringEvent.id), this.$root.token);
      this.forceFileDownload(file, `multi_report.xlsx`);
      this.downloading = false;
    },
    forceFileDownload(response, filename){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      // no filename in response :(
      link.setAttribute('download', filename) // have to specify a filename here
      document.body.appendChild(link)
      this.downloading = false;
      link.click()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/MultiAnalyse.vue